import React, { useEffect, useState } from "react"

import {
  Button,
  TextField,
  Typography,
  useTheme
} from "@mui/material"

import { ChevronRightRounded } from "@mui/icons-material"

import {
  useNavigate,
  useParams
} from "react-router-dom"

export default function NotFound() {
  const theme = useTheme()

  const navigate = useNavigate()

  const params = useParams()

  const [value, setValue] = useState()

  useEffect(() => {
    const queryParam = params["*"]
    setValue(queryParam)

    return () => {
      setValue()
    }
  }, [params["*"]])

  return <div className="page-landing">
    <figure className="cover">
      <img src="/static/images/404.jpg" />
    </figure>
    <div className="page-detail">
      <div className="page-detail-content">
        <section className="section section-intro">
          <div className="section-body">
            <div className="intro">
              <Typography variant="h1" className="intro-title">Pagina niet gevonden</Typography>
              <Typography className="intro-lead">De pagina die u zoekt is verplaatst of verwijderd.</Typography>
            </div>
          </div>
        </section>
        <section className="section section-rich-text">
          <div className="section-body">
            <div className="rich-text rich-text-full">
              <Typography sx={{ fontWeight: 700 }}>Zoekt u het volgende onderwerp?</Typography>
              <TextField
                value={value || ""}
                onChange={(event) => setValue(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    navigate(`/zoeken?keyword=${value}`)
                  }
                }}
                sx={{ margin: theme.spacing(1, 0, 3) }}
                size="small"
              />
              <Button
                disableElevation
                variant="contained"
                endIcon={<ChevronRightRounded />}
                size="large"
                sx={{
                  width: "fit-content",
                  "&:hover": {
                    textDecoration: "underline"
                  }
                }}
                onClick={() => {
                  navigate(`/zoeken?keyword=${value}`)
                }}
              >
                <Typography sx={{ fontSize: theme.typography.pxToRem(18), fontWeight: 700 }}>Zoeken</Typography>
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
}